import "../css/App.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { getImageUrl } from "../services/supabase";

const portrait1 = getImageUrl("general/Portretfoto.jpg");

function Homepage() {
    return (
        <section
            className="hero  main-section"
            id="hero"
        >
            <div className="hero-description">
                <h1 className="hero-heading">Scarlet Tummers</h1>
            </div>
            <LazyLoadImage
                src={portrait1}
                className="hero-img"
                effect="blur"
            />
        </section>
    );
}

export default Homepage;
